/**
 * Describes the layout the form should render
 */
import { getPropertyOf, hasPropertyOf } from '@cs/core/utils';
import { FormLayoutAnnotation }         from './form-layout-annotation.model';
import { WidgetAnnotation }             from './widget-annotation.model';
import { WidgetCollection }             from './widget-collection.model';
import { DataDescribedGroup }           from '../data-described/data-described-group.model';
import { GenericAction }                from '../data-described/actions/generic-action.model';
import { FormVisibilityRule }           from './form-visibility-rule.model';


export class FormAnnotation<T> {

	/**
	 * Identification of the form
	 */
	id: string;
	/**
	 * Name to show in the UI
	 */
	label?: string;
	/**
	 * Settings for the Form
	 */
	layout?: FormLayoutAnnotation;
	/**
	 * Group of Formfields could be used to visually group items in one form
	 */
	fieldSets?: DataDescribedGroup[];
	/**
	 * Group of widgets that should render as a group, like name = forename + lastname
	 */
	widgetCollections?: WidgetCollection[];

	widgets?: WidgetAnnotation<T>[];

	actions?: GenericAction[];

	/**
	 * Client-side visibility rules for conditional field display.
	 * Use this to show/hide fields based on other field values without server calls.
	 */
	visibilityRules?: FormVisibilityRule[];
	constructor(form: Partial<FormAnnotation<T>>) {
		this.id     = getPropertyOf(form, 'id', null);
		this.label  = getPropertyOf(form, 'label', null);
		this.layout = hasPropertyOf(form, 'layout')
									? new FormLayoutAnnotation(form.layout)
									: new FormLayoutAnnotation({});


		this.fieldSets = hasPropertyOf(form, 'fieldSets')
										 ?
										 form.fieldSets.map(fieldset => new DataDescribedGroup(fieldset))
										 : [];

		this.widgets = hasPropertyOf(form, 'widgets')
									 ?
									 form.widgets.map(widget => new WidgetAnnotation(widget))
									 : [];

		this.widgetCollections = hasPropertyOf(form, 'widgetCollections')
														 ?
														 form.widgetCollections.map(widget => new WidgetCollection(widget))
														 : [];

		this.visibilityRules = getPropertyOf(form, 'visibilityRules', []);
	}

}
